export default __webpack_public_path__ + "static/media/img_21.6d6a6d81.JPG";